import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { SpaceliftVcs } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

const SpaceliftVcsReposTableDescriptionCell = ({
  item: repo,
  ...cellProps
}: TableSimpleCellProps<SpaceliftVcs>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={repo.description} />
    </TableSimpleCell>
  );
};

export default SpaceliftVcsReposTableDescriptionCell;
